module.exports = __webpack_public_path__ + "static/media/panellist.86416ca0.svg";